export const sftimezones = [
  "(UTC-12:00) International Date Line West",
  "(UTC-11:00) Coordinated Universal Time-11",
  "(UTC-10:00) Aleutian Islands",
  "(UTC-10:00) Hawaii",
  "(UTC-09:30) Marquesas Islands",
  "(UTC-09:00) Alaska",
  "(UTC-09:00) Coordinated Universal Time-09",
  "(UTC-08:00) Baja California",
  "(UTC-08:00) Coordinated Universal Time-08",
  "(UTC-08:00) Pacific Time (US & Canada)",
  "(UTC-07:00) Arizona",
  "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  "(UTC-07:00) Mountain Time (US & Canada)",
  "(UTC-06:00) Central America",
  "(UTC-06:00) Central Time (US & Canada)",
  "(UTC-06:00) Easter Island",
  "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  "(UTC-06:00) Saskatchewan",
  "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
  "(UTC-05:00) Chetumal",
  "(UTC-05:00) Eastern Time (US & Canada)",
  "(UTC-05:00) Haiti",
  "(UTC-05:00) Indiana (East)",
  "(UTC-04:00) Asuncion",
  "(UTC-04:00) Atlantic Time (Canada)",
  "(UTC-04:00) Caracas",
  "(UTC-04:00) Cuiaba",
  "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  "(UTC-04:00) Santiago",
  "(UTC-04:00) Turks and Caicos",
  "(UTC-03:30) Newfoundland",
  "(UTC-03:00) Araguaina",
  "(UTC-03:00) Brasilia",
  "(UTC-03:00) Cayenne, Fortaleza",
  "(UTC-03:00) City of Buenos Aires",
  "(UTC-03:00) Greenland",
  "(UTC-03:00) Montevideo",
  "(UTC-03:00) Salvador",
  "(UTC-03:00) Saint Pierre and Miquelon",
  "(UTC-02:00) Coordinated Universal Time-02",
  "(UTC-02:00) Mid-Atlantic",
  "(UTC-01:00) Azores",
  "(UTC-01:00) Cape Verde Is.",
  "(UTC) Casablanca",
  "(UTC) Coordinated Universal Time",
  "(UTC) Dublin, Edinburgh, Lisbon, London",
  "(UTC) Monrovia, Reykjavik",
  "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  "(UTC+01:00) West Central Africa",
  "(UTC+01:00) Windhoek",
  "(UTC+02:00) Amman",
  "(UTC+02:00) Athens, Bucharest",
  "(UTC+02:00) Beirut",
  "(UTC+02:00) Cairo",
  "(UTC+02:00) Chisinau",
  "(UTC+02:00) Damascus",
  "(UTC+02:00) Gaza, Hebron",
  "(UTC+02:00) Harare, Pretoria",
  "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  "(UTC+02:00) Jerusalem",
  "(UTC+02:00) Kaliningrad",
  "(UTC+02:00) Tripoli",
  "(UTC+03:00) Baghdad",
  "(UTC+03:00) Istanbul",
  "(UTC+03:00) Kuwait, Riyadh",
  "(UTC+03:00) Minsk",
  "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
  "(UTC+03:00) Nairobi",
  "(UTC+03:30) Tehran",
  "(UTC+04:00) Abu Dhabi, Muscat",
  "(UTC+04:00) Astrakhan, Ulyanovsk",
  "(UTC+04:00) Baku",
  "(UTC+04:00) Izhevsk, Samara",
  "(UTC+04:00) Port Louis",
  "(UTC+04:00) Tbilisi",
  "(UTC+04:00) Yerevan",
  "(UTC+04:30) Kabul",
  "(UTC+05:00) Ashgabat, Tashkent",
  "(UTC+05:00) Ekaterinburg",
  "(UTC+05:00) Islamabad, Karachi",
  "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  "(UTC+05:30) Sri Jayawardenepura",
  "(UTC+05:45) Kathmandu",
  "(UTC+06:00) Astana",
  "(UTC+06:00) Dhaka",
  "(UTC+06:00) Omsk",
  "(UTC+06:30) Yangon (Rangoon)",
  "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  "(UTC+07:00) Barnaul, Gorno-Altaysk",
  "(UTC+07:00) Hovd",
  "(UTC+07:00) Krasnoyarsk",
  "(UTC+07:00) Novosibirsk",
  "(UTC+07:00) Tomsk",
  "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  "(UTC+08:00) Irkutsk",
  "(UTC+08:00) Kuala Lumpur, Singapore",
  "(UTC+08:00) Perth",
  "(UTC+08:00) Taipei",
  "(UTC+08:00) Ulaanbaatar",
  "(UTC+08:30) Pyongyang",
  "(UTC+08:45) Eucla",
  "(UTC+09:00) Chita",
  "(UTC+09:00) Osaka, Sapporo, Tokyo",
  "(UTC+09:00) Seoul",
  "(UTC+09:00) Yakutsk",
  "(UTC+09:30) Adelaide",
  "(UTC+09:30) Darwin",
  "(UTC+10:00) Brisbane",
  "(UTC+10:00) Canberra, Melbourne, Sydney",
  "(UTC+10:00) Guam, Port Moresby",
  "(UTC+10:00) Hobart",
  "(UTC+10:00) Vladivostok",
  "(UTC+10:30) Lord Howe Island",
  "(UTC+11:00) Bougainville Island",
  "(UTC+11:00) Chokurdakh",
  "(UTC+11:00) Magadan",
  "(UTC+11:00) Norfolk Island",
  "(UTC+11:00) Sakhalin",
  "(UTC+11:00) Solomon Is., New Caledonia",
  "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
  "(UTC+12:00) Auckland, Wellington",
  "(UTC+12:00) Coordinated Universal Time+12",
  "(UTC+12:00) Fiji",
  "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
  "(UTC+12:45) Chatham Islands",
  "(UTC+13:00) Nuku'alofa",
  "(UTC+13:00) Samoa",
  "(UTC+14:00) Kiritimati Island",
];

export const mstimezones = [
  {
    name: "(UTC-12:00) International Date Line West",
    country: ["UM"],
    momenttz: "Etc/GMT+12",
  },
  {
    name: "(UTC-11:00) Coordinated Universal Time-11",
    country: ["WS", "AS", "NU"],
    momenttz: "Etc/GMT+11",
  },
  {
    name: "(UTC-10:00) Aleutian Islands",
    momenttz: "America/Adak",
  },
  {
    name: "(UTC-10:00) Hawaii",
    country: ["CK", "PF"],
    momenttz: "Pacific/Honolulu",
  },
  {
    name: "(UTC-09:30) Marquesas Islands",
    momenttz: "Pacific/Marquesas",
  },
  {
    name: "(UTC-09:00) Alaska",
    momenttz: "America/Anchorage",
  },
  {
    name: "(UTC-09:00) Coordinated Universal Time-09",
    momenttz: "Etc/GMT+9",
  },
  {
    name: "(UTC-08:00) Baja California",
    momenttz: "America/Tijuana",
  },
  {
    name: "(UTC-08:00) Coordinated Universal Time-08",
    momenttz: "Etc/GMT+8",
  },
  {
    name: "(UTC-08:00) Pacific Time (US & Canada)",
    country: ["PN"],
    momenttz: "America/Los_Angeles",
  },
  {
    name: "(UTC-07:00) Arizona",
    momenttz: "America/Phoenix",
  },
  {
    name: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
    momenttz: "America/Chihuahua",
  },
  {
    name: "(UTC-07:00) Mountain Time (US & Canada)",
    momenttz: "America/Boise",
  },
  {
    name: "(UTC-06:00) Central America",
    country: ["BZ", "CR", "SV", "GT", "HN", "NI"],
    momenttz: "America/Bahia_Banderas",
  },
  {
    name: "(UTC-06:00) Central Time (US & Canada)",
    momenttz: "America/Chicago",
  },
  {
    name: "(UTC-06:00) Easter Island",
    momenttz: "Pacific/Easter",
  },
  {
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
    country: ["MX"],
    momenttz: "America/Mexico_City",
  },
  {
    name: "(UTC-06:00) Saskatchewan",
    momenttz: "Canada/Saskatchewan",
  },
  {
    name: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
    country: ["CO", "EC", "PE"],
    momenttz: "America/Bogota",
  },
  {
    name: "(UTC-05:00) Chetumal",
    momenttz: "Etc/GMT+5",
  }, // guessed
  {
    name: "(UTC-05:00) Eastern Time (US & Canada)",
    country: ["BS", "KY", "JM", "PA", "US"],
    momenttz: "America/New_York",
  },
  {
    name: "(UTC-05:00) Haiti",
    country: ["HT", "TF"],
    momenttz: "America/Port-au-Prince",
  }, // guessed
  {
    name: "(UTC-05:00) Indiana (East)",
    momenttz: "America/Indiana/Indianapolis",
  },
  {
    name: "(UTC-04:00) Asuncion",
    country: ["PY"],
    momenttz: "America/Asuncion",
  },
  {
    name: "(UTC-04:00) Atlantic Time (Canada)",
    country: [
      "AI",
      "AG",
      "AW",
      "BB",
      "BM",
      "DM",
      "DO",
      "GD",
      "GP",
      "GY",
      "MQ",
      "MS",
      "AN",
      "PR",
      "KN",
      "LC",
      "VC",
      "TT",
      "VG",
      "VI",
    ],
    momenttz: "Canada/Eastern",
  },
  {
    name: "(UTC-04:00) Caracas",
    country: ["VE"],
    momenttz: "America/Caracas",
  },
  {
    name: "(UTC-04:00) Cuiaba",
    momenttz: "America/Cuiaba",
  },
  {
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
    country: ["BO"],
    momenttz: "America/La_Paz",
  },
  {
    name: "(UTC-04:00) Santiago",
    country: ["CL"],
    momenttz: "America/Santiago",
  },
  {
    name: "(UTC-04:00) Turks and Caicos",
    country: ["TC"],
    momenttz: "Etc/GMT+4",
  }, // guessed
  {
    name: "(UTC-03:30) Newfoundland",
    momenttz: "Canada/Newfoundland",
  },
  {
    name: "(UTC-03:00) Araguaina",
    momenttz: "America/Araguaina",
  },
  {
    name: "(UTC-03:00) Brasilia",
    country: ["BR", "SR"],
    momenttz: "America/Sao_Paulo",
  },
  {
    name: "(UTC-03:00) Cayenne, Fortaleza",
    country: ["GF"],
    momenttz: "America/Cayenne",
  },
  {
    name: "(UTC-03:00) City of Buenos Aires",
    country: ["AR", "FK"],
    momenttz: "America/Argentina/Buenos_Aires",
  },
  {
    name: "(UTC-03:00) Greenland",
    country: ["GL"],
    momenttz: "America/Godthab",
  },
  {
    name: "(UTC-03:00) Montevideo",
    country: ["UY"],
    momenttz: "America/Montevideo",
  },
  {
    name: "(UTC-03:00) Salvador",
    momenttz: "America/Bahia",
  },
  {
    name: "(UTC-03:00) Saint Pierre and Miquelon",
    country: ["PM"],
    momenttz: "America/Miquelon",
  },
  {
    name: "(UTC-02:00) Coordinated Universal Time-02",
    country: ["GS"],
    momenttz: "Etc/GMT+2",
  },
  {
    name: "(UTC-02:00) Mid-Atlantic",
    momenttz: "America/Noronha",
  },
  {
    name: "(UTC-01:00) Azores",
    momenttz: "Atlantic/Azores",
  },
  {
    name: "(UTC-01:00) Cape Verde Is.",
    country: ["CV"],
    momenttz: "Atlantic/Cape_Verde",
  },
  {
    name: "(UTC) Casablanca",
    country: [
      "MA",
      "BF",
      "CI",
      "GM",
      "GH",
      "GN",
      "GW",
      "ML",
      "MR",
      "ST",
      "SN",
      "SL",
      "TG",
    ],
    momenttz: "Africa/Casablanca",
  },
  {
    name: "(UTC) Coordinated Universal Time",
    momenttz: "Etc/UTC",
  },
  {
    name: "(UTC) Dublin, Edinburgh, Lisbon, London",
    country: ["IE", "GB", "PT", "FO"],
    momenttz: "Europe/Dublin",
  },
  {
    name: "(UTC) Monrovia, Reykjavik",
    country: ["LR", "IS", "SH"],
    momenttz: "Africa/Monrovia",
  },
  {
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    country: ["DE", "IT", "SE", "AT", "NL", "CH", "BV", "NO", "SM", "VA"],
    momenttz: "Europe/Amsterdam",
  },
  {
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    country: ["RS", "SK", "HU", "SI", "CZ"],
    momenttz: "Europe/Belgrade",
  },
  {
    name: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
    country: ["BE", "ES", "FR", "DK", "AD", "GI", "LI", "LU", "MC", "SJ"],
    momenttz: "Europe/Brussels",
  },
  {
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    country: ["BA", "MK", "PL", "HR", "AL", "MT"],
    momenttz: "Europe/Sarajevo",
  },
  {
    name: "(UTC+01:00) West Central Africa",
    country: [
      "DZ",
      "BJ",
      "CM",
      "CF",
      "TD",
      "CG",
      "GQ",
      "GA",
      "NE",
      "NG",
      "CD",
      "TN",
      "EH",
    ],
    momenttz: "Africa/Algiers",
  },
  {
    name: "(UTC+01:00) Windhoek",
    country: ["NA"],
    momenttz: "Africa/Windhoek",
  },
  {
    name: "(UTC+02:00) Amman",
    country: ["JO"],
    momenttz: "Asia/Amman",
  },
  {
    name: "(UTC+02:00) Athens, Bucharest",
    country: ["GR", "RO"],
    momenttz: "Europe/Bucharest",
  },
  {
    name: "(UTC+02:00) Beirut",
    country: ["LB"],
    momenttz: "Asia/Beirut",
  },
  {
    name: "(UTC+02:00) Cairo",
    country: ["EG"],
    momenttz: "Africa/Cairo",
  },
  {
    name: "(UTC+02:00) Chisinau",
    country: ["MD"],
    momenttz: "Europe/Chisinau",
  },
  {
    name: "(UTC+02:00) Damascus",
    country: ["SY"],
    momenttz: "Asia/Damascus",
  },
  {
    name: "(UTC+02:00) Gaza, Hebron",
    momenttz: "Asia/Gaza",
  },
  {
    name: "(UTC+02:00) Harare, Pretoria",
    country: ["ZW", "ZA", "BW", "BI", "LS", "MG", "MW", "MZ", "SZ", "ZM"],
    momenttz: "Africa/Harare",
  },
  {
    name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    country: ["FI", "UA", "LV", "BG", "EE", "LT", "CY"],
    momenttz: "Europe/Kiev",
  },
  {
    name: "(UTC+02:00) Jerusalem",
    country: ["IL"],
    momenttz: "Asia/Jerusalem",
  },
  {
    name: "(UTC+02:00) Kaliningrad",
    momenttz: "Europe/Kaliningrad",
  },
  {
    name: "(UTC+02:00) Tripoli",
    momenttz: "Africa/Tripoli",
  },
  {
    name: "(UTC+03:00) Baghdad",
    momenttz: "Asia/Baghdad",
  },
  {
    name: "(UTC+03:00) Istanbul",
    country: ["TR"],
    momenttz: "Asia/Istanbul",
  },
  {
    name: "(UTC+03:00) Kuwait, Riyadh",
    country: ["KW", "SA", "BH", "QA", "YE"],
    momenttz: "Asia/Kuwait",
  },
  {
    name: "(UTC+03:00) Minsk",
    country: ["BY"],
    momenttz: "Europe/Minsk",
  },
  {
    name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
    country: ["RU"],
    momenttz: "Europe/Moscow",
  },
  {
    name: "(UTC+03:00) Nairobi",
    country: ["KE", "KM", "DJ", "ER", "ET", "YT", "SO", "TZ", "UG"],
    momenttz: "Africa/Nairobi",
  },
  {
    name: "(UTC+03:30) Tehran",
    momenttz: "Asia/Tehran",
  },
  {
    name: "(UTC+04:00) Abu Dhabi, Muscat",
    country: ["AE", "OM"],
    momenttz: "Asia/Muscat",
  },
  {
    name: "(UTC+04:00) Astrakhan, Ulyanovsk",
    momenttz: "Europe/Astrakhan",
  },
  { name: "(UTC+04:00) Baku", country: ["AZ"], momenttz: "Asia/Baku" },
  {
    name: "(UTC+04:00) Izhevsk, Samara",
    momenttz: "Europe/Samara",
  },
  {
    name: "(UTC+04:00) Port Louis",
    country: ["MU", "RE", "SC"],
    momenttz: "Indian/Mauritius",
  },
  {
    name: "(UTC+04:00) Tbilisi",
    country: ["GE"],
    momenttz: "Asia/Tbilisi",
  },
  {
    name: "(UTC+04:00) Yerevan",
    country: ["AM"],
    momenttz: "Asia/Yerevan",
  },
  {
    name: "(UTC+04:30) Kabul",
    country: ["AF"],
    momenttz: "Asia/Kabul",
  },
  {
    name: "(UTC+05:00) Ashgabat, Tashkent",
    country: ["TM", "UZ", "HM", "KZ", "KG", "MV", "TJ"],
    momenttz: "Asia/Tashkent",
  },
  {
    name: "(UTC+05:00) Ekaterinburg",
    momenttz: "Asia/Ashgabat",
  },
  {
    name: "(UTC+05:00) Islamabad, Karachi",
    country: ["PK"],
    momenttz: "Asia/Karachi",
  },
  {
    name: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    country: ["IN"],
    momenttz: "Asia/Kolkata",
  },
  {
    name: "(UTC+05:30) Sri Jayawardenepura",
    country: ["LK"],
    momenttz: "Asia/Colombo",
  }, // guessed
  {
    name: "(UTC+05:45) Kathmandu",
    country: ["NP"],
    momenttz: "Asia/Kathmandu",
  },
  {
    name: "(UTC+06:00) Astana",
    momenttz: "Asia/Dhaka",
  },
  {
    name: "(UTC+06:00) Dhaka",
    country: ["BD", "BT", "IO"],
    momenttz: "Asia/Dhaka",
  },
  { name: "(UTC+06:00) Omsk", momenttz: "Asia/Omsk" },
  {
    name: "(UTC+06:30) Yangon (Rangoon)",
    country: ["MM", "CC"],
    momenttz: "Asia/Rangoon",
  },
  {
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    country: ["TH", "VN", "ID", "KH", "CX", "LA"],
    momenttz: "Asia/Bangkok",
  },
  {
    name: "(UTC+07:00) Barnaul, Gorno-Altaysk",
    momenttz: "Asia/Barnaul",
  },
  { name: "(UTC+07:00) Hovd", momenttz: "Asia/Hovd" },
  {
    name: "(UTC+07:00) Krasnoyarsk",
    momenttz: "Asia/Krasnoyarsk",
  },
  {
    name: "(UTC+07:00) Novosibirsk",
    momenttz: "Asia/Novosibirsk",
  },
  {
    name: "(UTC+07:00) Tomsk",
    momenttz: "Asia/Tomsk",
  },
  {
    name: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    country: ["CN", "HK", "MO"],
    momenttz: "Asia/Shanghai",
  },
  {
    name: "(UTC+08:00) Irkutsk",
    momenttz: "Asia/Irkutsk",
  },
  {
    name: "(UTC+08:00) Kuala Lumpur, Singapore",
    country: ["MY", "SG", "BN", "PH"],
    momenttz: "Asia/Singapore",
  },
  {
    name: "(UTC+08:00) Perth",
    momenttz: "Australia/Perth",
  },
  {
    name: "(UTC+08:00) Taipei",
    country: ["TW"],
    momenttz: "Asia/Taipei",
  },
  {
    name: "(UTC+08:00) Ulaanbaatar",
    country: ["MN"],
    momenttz: "Asia/Ulaanbaatar",
  },
  {
    name: "(UTC+08:30) Pyongyang",
    momenttz: "Asia/Pyongyang",
  },
  {
    name: "(UTC+08:45) Eucla",
    momenttz: "Australia/Eucla",
  },
  {
    name: "(UTC+09:00) Chita",
    momenttz: "Asia/Chita",
  },
  {
    name: "(UTC+09:00) Osaka, Sapporo, Tokyo",
    country: ["JP", "TP", "PW", "TL"],
    momenttz: "Asia/Tokyo",
  },
  {
    name: "(UTC+09:00) Seoul",
    country: ["KR"],
    momenttz: "Asia/Seoul",
  },
  {
    name: "(UTC+09:00) Yakutsk",
    momenttz: "Asia/Yakutsk",
  },
  {
    name: "(UTC+09:30) Adelaide",
    momenttz: "Australia/Adelaide",
  },
  {
    name: "(UTC+09:30) Darwin",
    momenttz: "Australia/Darwin",
  },
  {
    name: "(UTC+10:00) Brisbane",
    momenttz: "Australia/Brisbane",
  },
  {
    name: "(UTC+10:00) Canberra, Melbourne, Sydney",
    country: ["AU"],
    momenttz: "Australia/Sydney",
  },
  {
    name: "(UTC+10:00) Guam, Port Moresby",
    country: ["GU", "PG", "FM", "MP"],
    momenttz: "Pacific/Guam",
  },
  {
    name: "(UTC+10:00) Hobart",
    momenttz: "Australia/Hobart",
  },
  {
    name: "(UTC+10:00) Vladivostok",
    momenttz: "Asia/Vladivostok",
  },
  {
    name: "(UTC+10:30) Lord Howe Island",
    momenttz: "Australia/Lord_Howe",
  },
  {
    name: "(UTC+11:00) Bougainville Island",
    momenttz: "Pacific/Bougainville",
  },
  {
    name: "(UTC+11:00) Chokurdakh",
    momenttz: "Asia/Srednekolymsk",
  }, //guessed
  {
    name: "(UTC+11:00) Magadan",
    momenttz: "Asia/Magadan",
  },
  {
    name: "(UTC+11:00) Norfolk Island",
    country: ["NF"],
    momenttz: "Pacific/Norfolk",
  },
  {
    name: "(UTC+11:00) Sakhalin",
    momenttz: "Asia/Sakhalin",
  },
  {
    name: "(UTC+11:00) Solomon Is., New Caledonia",
    country: ["SB", "NC", "VU"],
    momenttz: "Pacific/Efate",
  }, // guessed
  {
    name: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
    momenttz: "Asia/Anadyr",
  },
  {
    name: "(UTC+12:00) Auckland, Wellington",
    country: ["NZ"],
    momenttz: "Pacific/Auckland",
  },
  {
    name: "(UTC+12:00) Coordinated Universal Time+12",
    country: ["WF", "MH", "NR", "TV"],
    momenttz: "Etc/GMT-12",
  },
  {
    name: "(UTC+12:00) Fiji",
    country: ["FJ"],
    momenttz: "Pacific/Fiji",
  },
  {
    name: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
    momenttz: "Asia/Kamchatka",
  },
  {
    name: "(UTC+12:45) Chatham Islands",
    momenttz: "Pacific/Chatham",
  },
  {
    name: "(UTC+13:00) Nuku'alofa",
    country: ["TO", "TK"],
    momenttz: "Pacific/Tongatapu",
  },
  {
    name: "(UTC+13:00) Samoa",
    country: ["WS"],
    momenttz: "Pacific/Samoa",
  },
  {
    name: "(UTC+14:00) Kiritimati Island",
    country: ["KI"],
    momenttz: "Pacific/Kiritimati",
  },
];
